import React from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { routeConfig } from "./Routes";

const router = createBrowserRouter(routeConfig);

const AppRouter: React.FC = () => {
  return <RouterProvider router={router} />;
};

export default AppRouter;
